import { createStyles } from '@mantine/styles';
var sizes = {
  xs: 320,
  sm: 380,
  md: 440,
  lg: 620,
  xl: 780,
  full: "100%"
};
var useStyles = createStyles(function (theme, _ref) {
  var overflow = _ref.overflow,
    size = _ref.size,
    centered = _ref.centered;
  return {
    root: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    inner: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflowY: "auto",
      padding: "".concat(theme.spacing.xl * 2, "px ").concat(theme.spacing.md, "px"),
      display: "flex",
      justifyContent: "center",
      alignItems: centered ? "center" : "flex-start"
    },
    clickOutsideOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    title: {
      marginRight: theme.spacing.md,
      textOverflow: "ellipsis",
      display: "block",
      wordBreak: "break-word"
    },
    modal: {
      width: theme.fn.size({
        sizes: sizes,
        size: size
      }),
      outline: 0,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: theme.spacing.md,
      marginRight: -9
    },
    body: {
      maxHeight: overflow === "inside" ? "calc(100vh - 185px)" : null,
      overflowY: overflow === "inside" ? "auto" : null,
      wordBreak: "break-word"
    }
  };
});
export default useStyles;
export { sizes };